// store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import signupReducer from './reducers/signupstate';


const store = configureStore({
  reducer: {
    auth:rootReducer,
    signup:signupReducer
  },
});

export default store;
